import { URLQueryMappingOption } from 'airbridge-web-sdk-loader/build/airbridge_api/init';

export type DynamicLinkParams = URLQueryMappingOption & {
  cta_param_1?: string | number;
  cta_param_2?: string | number;
  cta_param_3?: string | number;
  invitationCode?: string;
};

export enum DynamicLinkPosition {
  Drawer = 'drawer',
  Gnb = 'gnb',
  Lnb = 'lnb',
  Footer = 'footer',
  Content = 'content',
}

export enum DynamicLinkContentFeature {
  Button = 'btn',
  Modal = 'mdl',
  Floating = 'flt',
  Banner = 'bnr',
  Snippet = 'snippet',
}

export enum DynamicLinkContentPage {
  All = 'all', // 모든 페이지에서 동일하게 뜨는 경우(EX. 모바일 웹의 햄버거)
  Main = 'main', // 메인페이지
  Service = 'service', // 메인 페이지 외 모든 페이지에 동일하게 뜨는 경우 (EX PC웹 LNB)
  List = 'list', // 리스트 페이지
  Detail = 'details', // 상세페이지
}

export type DynamicLinkContent = `web_${DynamicLinkPosition}_${DynamicLinkContentFeature}_${DynamicLinkContentPage}`;

export type DynamicLinkOptions = Omit<DynamicLinkParams, 'channel' | 'content'> & {
  content?: DynamicLinkContent;
};

/**
 * Airbridge 다이나믹 링크 타입
 * 각 타입에 따라 다른 트래킹 파라미터가 적용됩니다
 */
export enum EAirbridgeLinkType {
  /** 일반 앱 다운로드 링크 (기본값) */
  GENERAL = 'GENERAL',
  /** 앱스토어 페이지 직접 이동 링크 */
  STORE_PAGE = 'STORE_PAGE',
  /** 탈모 카테고리 전용 링크 */
  HAIRLOSS = 'HAIRLOSS',
  /** 여드름 카테고리 전용 링크 */
  ACNE = 'ACNE',
  /** 다이어트 카테고리 전용 링크 */
  DIET = 'DIET',
}
